import { render, staticRenderFns } from "./DashboardInquiries.vue?vue&type=template&id=5fb2d82f"
import script from "./DashboardInquiries.vue?vue&type=script&lang=ts"
export * from "./DashboardInquiries.vue?vue&type=script&lang=ts"
import style0 from "./DashboardInquiries.vue?vue&type=style&index=0&id=5fb2d82f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports